import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import ApiProvider from "../../apiProvider";
import { Spinner } from "react-bootstrap";
import "./PDFViewer.css";

const PDFViewer = ({ fileName, setFileName }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [fileData, setFileData] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function getData() {
            if (!fileName || fileName === "") {
                return;
            }

            console.log(`Loaded PDF View Component ${fileName}`);
            setIsLoading(true);
            let result = await apiProvider.Get(
                fileName,
                null,
                "application/pdf",
                false
            );
            if (!result.error) {
                setFileData(result);
            }
            setIsLoading(false);
        }

        getData();
    }, [fileName]);

    return (
        <>
            {fileName !== undefined && fileName !== "" ? (
                <>
                    <div className="curtain"></div>
                    <div className="pdf-viewer">
                        <div className="control-wrapper">
                            <button
                                className="btn btn-link cds-link"
                                onClick={() => setFileName("")}
                            >
                                Close File
                            </button>
                        </div>
                        <div className="iframe-wrapper">
                            {isLoading ? (
                                <div className="spinner">
                                    <Spinner></Spinner>
                                    <p>Loading...</p>
                                </div>
                            ) : (
                                <iframe
                                    className="responsive-iframe"
                                    src={`data:application/pdf;base64,${fileData}`}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default PDFViewer;
